import { render, staticRenderFns } from "./fun-create-dialog.vue?vue&type=template&id=e883979e&"
import script from "./fun-create-dialog.vue?vue&type=script&lang=ts&"
export * from "./fun-create-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./fun-create-dialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports